import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { SavedGrocery } from '@/models/grocery';

export const fetchSavedGrocery = async (id: number): Promise<SavedGrocery> => {
  const response = await queryExecute({
    query: graphql(`
      query savedGrocery($id: Float!) {
        savedGrocery(id: $id) {
          id
          name
          type
          callerId
          address
          streetAddress
          streetAddress2
          city
          state
          zip
          country
          latitude
          longitude
          notes
          order
          groceryStoreId
          storeName
          storeLogo
          storeId
          createdAt
          updatedAt
          createdBy {
            lastName
            firstName
            id
          }
          updatedBy {
            lastName
            firstName
            id
          }
          store {
            id
            name
            slug
            logo
            storeId
            createdAt
            updatedAt
          }
          storeItems {
            id
            savedGroceryId
            groceryItemId
            replacementItemId
            replacementItemQty
            qty
            instruction
            replacementPolicy
            groceryItem {
              id
              name
              img
              unit
              size
              price
              productId
              productName
              createdAt
              updatedAt
              itemId
              groceryProduct {
                id
                name
                createdAt
                updatedAt
              }
            }
            replacementItem {
              id
              name
              img
              unit
              size
              price
              productId
              productName
              createdAt
              updatedAt
              itemId
              groceryProduct {
                id
                name
                createdAt
                updatedAt
              }
            }
          }
        }
      }
    `),
    variables: {
      id,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.savedGrocery;
};
